import CarContainer1, { NormalCard, VehicleListingCard, CarListingCard } from '@common/pages/Dashboard/components/CarContainer1';
import CarsList from '@common/pages/Dashboard/components/CarsList';
import { auctionTypes } from '@common/utils/constants/auction';
import { Box, Pagination, Paper, Skeleton, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import debounce from 'lodash.debounce'; // Import debounce function
import React from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import { useDispatch } from 'react-redux';
import { baseImageUrl } from '../../../../api.js';
import theme from '../../../../theme.js';
import { useLazyFetchCarsQuery, useLazyFetchOtherCarsQuery, useLazyFetchOwnCarsQuery } from '../../../../toolkit/upcomingCars/upcomingCarsApi';
import { useCancelAuctionHandler } from '../LiveAuction/customHooks/useCancelAuctionHandler.js';
// import MyCarsOrOtherCarsButton, { defaultValue } from "../common/MyCarsOrOtherCarsButton.jsx";
import { carContainerTypes } from '@common/utils/constants/ui/carContainers';
import { useLogPageVisitMutation } from "@common/toolkit/appConfiguration/appConfigurationApi.js";
import MyCarsOrOtherCarsButton, { defaultValue } from '@common/pages/Dashboard/components/common/MyCarsOrOtherCarsButton.jsx';
import { getUpcomingCarRemainingSeconds } from '@common/utils/methods/generalVehicleMethods.js';

const UpcomingCarsList = ({ setDetailView, onCarClick }) => {
  // useDispatch...
  const dispatch = useDispatch();
  const { t } = useTranslation('upcomingCars'); // Add this line - you can specify namespace if needed
  const muiTheme = useTheme();

  // Responsive breakpoints
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(muiTheme.breakpoints.between('sm', 'md'));
  // useDispatch...

  const paginationDataInit = React.useMemo(() => {
    return {
      current_page: 1,
      per_page: 10,
      isFetching: true,
      data: [],
    };
  }, []);

  const pageTabs = {
    liveAuction: 'live_auction',
    buyNow: 'buy_now',
  };

  const pageTabsReverseMapping = React.useMemo(() => {
    return {
      live_auction: 'liveAuction',
      buy_now: 'buyNow',
    };
  }, []);

  const [makeOptions, setMakeOptions] = React.useState([]);
  const [yearOptions, setYearOptions] = React.useState([]);
  const [modelOptions, setModelOptions] = React.useState([]);
  const [isModelOptionsLoading, setIsModelOptionsLoading] = React.useState(false);

  // paginated data...
  const [carList, setCarList] = React.useState([]);
  // paginated data...

  const [allMakes, setAllMakes] = React.useState([]);
  const [allModels, setAllModels] = React.useState([]);
  const [allYears, setAllYears] = React.useState([]);

  const [selectedMakes, setSelectedMakes] = React.useState(['']);
  const [selectedModels, setSelectedModels] = React.useState(['']);
  const [selectedYearFrom, setSelectedYearFrom] = React.useState('');
  const [selectedYearTo, setSelectedYearTo] = React.useState('');
  const [odometerFrom, setOdometerFrom] = React.useState('');
  const [odometerTo, setOdometerTo] = React.useState('');
  const [selectedBrands, setSelectedBrands] = React.useState([]);
  const [paginationData, setPaginationData] = React.useState(paginationDataInit);

  const [value, setValue] = React.useState(/*defaultValue*/0);
  const [pageTab, setPageTab] = React.useState(pageTabs.liveAuction);

  const params = React.useMemo(() => {
    return {
      Year: selectedYearFrom,
      Make: selectedMakes?.map((item) => item?.label)?.join(','), // Pass make names
      Model: selectedModels?.map((item) => item?.label)?.join?.(','), // Pass model names
      from_year: selectedYearFrom,
      to_year: selectedYearTo,
      from_Mileage: odometerFrom,
      to_Mileage: odometerTo,
      auction_type: pageTab,
      page: paginationData?.current_page,
      per_page: paginationData?.per_page,
    };
  }, [
    selectedYearFrom,
    selectedMakes,
    selectedModels,
    selectedYearFrom,
    selectedYearTo,
    odometerFrom,
    odometerTo,
    pageTab,
  ]);

  // custom hooks start...
  // const [getFetchCarsApiHandler, getFetchCarsApiData] = useLazyFetchCarsQuery();
  const [getFetchOwnCarsApiHandler, getFetchOwnCarsApiData] = useLazyFetchOwnCarsQuery();
  const [getFetchOtherCarsApiHandler, getFetchOtherCarsApiData] = useLazyFetchOtherCarsQuery();
  const { onCancelAuctionHandler } = useCancelAuctionHandler();
  const [logPageVisitApiHandler, logPageVisitApiData] = useLogPageVisitMutation();
  // custom hooks end...

  // Handlers start...
  const fetchPaginationDataHandler = async ({ params }) => {
    let res;
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        isFetching: true,
      };
    });

    // res = await getFetchCarsApiHandler({
    //   params,
    // });

    console.log(value, `fetchPaginationDataHandler`);

    if (value === 0) {
      res = await getFetchOwnCarsApiHandler({
        params,
      });
    } else if (value === 1) {
      res = await getFetchOtherCarsApiHandler({
        params,
      });
    }

    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        data: res?.data?.Vehicle?.data,
        isFetching: false,
      };
    });
  };

  const handlePageChange = (e, page) => {
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        current_page: page,
      };
    });
  };

  const handleChange = (event, newValue) => {
    setPageTab(newValue);
  };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    const debouncedFetchData = debounce(async () => {
      await fetchPaginationDataHandler({
        params,
      });
    }, 1000);

    debouncedFetchData();

    return () => {
      debouncedFetchData.cancel(); // Cleanup function to cancel pending calls
    };
  }, [params]);

  React.useEffect(() => {
    (async () => {
      await fetchPaginationDataHandler({
        params,
      });
    })();
  }, [
    value,
    paginationData?.current_page
  ]);

  React.useEffect(() => {
    if (selectedMakes?.length === 0) {
      setSelectedMakes(['']);
    }

    if (selectedModels?.length === 0) {
      setSelectedModels(['']);
    }
  }, [selectedMakes, selectedModels]);

  // React.useEffect(() => {
  //   if (value === 0) {
  //     setPageTab(pageTabs.liveAuction);
  //   } else {
  //     setPageTab(pageTabs.buyNow);
  //   }
  // }, [value]);

  React.useEffect(() => {
    (async () => {
      await logPageVisitApiHandler({
        payload: {
          page_id: 3
        }
      });
    })();
  }, []);
  // useEffect end...

  return (
    <Box
      display={'flex'}
      width={'100%'}
      sx={{
        borderRadius: '24px',
        height: { md: `calc(100vh - 92px)`, sm: `calc(100vh - 112px)`, xs: 'auto' },
        position: 'relative',
      }}
    >
      <Box
        sx={{
          flex: '1',
          display: 'flex',
          flexDirection: 'column',
          background: theme.palette.background.paper,
          borderRadius: '24px',
          width: '100%',
        }}
      >
        <Paper elevation={0} sx={{ borderRadius: '24px' }}>
          <Box sx={{ padding: { xs: 2, sm: 3, md: 3 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2, sm: 1 },
              }}
            >
              <Typography
                variant={'h1'}
                sx={{
                  fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                }}
              >
                {t('upcomingCars')}
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                {/* <Box
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-start' },
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      border: '1px solid',
                      borderColor: 'border.main',
                      p: 0.5,
                      borderRadius: 2,
                      overflow: 'hidden',
                      width: { xs: '100%', sm: 'auto' },
                    }}
                  >
                    <Tabs
                      fullWidth
                      value={pageTab}
                      onChange={handleChange}
                      slotProps={{
                        indicator: { style: { display: 'none' } },
                      }}
                      sx={{
                        width: '100%',
                        '& .MuiTabs-flexContainer': {
                          height: '100%',
                        },
                        '& .MuiTab-root': {
                          color: 'text.primary',
                          padding: { xs: '0.5rem 1rem', sm: '0.75rem 1.5rem' },
                          fontSize: { xs: '0.875rem', sm: '1rem' },
                          textTransform: 'none',
                          fontWeight: 500,
                          minHeight: { xs: '36px', sm: '48px' },
                          '&.Mui-selected': {
                            borderRadius: 2,
                            backgroundColor: 'primary.main',
                            color: 'white',
                          },
                        },
                      }}
                    >
                      <Tab fullWidth sx={{ width: '50%', textWrap: 'nowrap' }} label={t('liveAuction')} value={pageTabs.liveAuction} />
                      <Tab fullWidth sx={{ width: '50%', textWrap: 'nowrap' }} label={t('buyNow')} value={pageTabs.buyNow} />
                    </Tabs>
                  </Box>
                </Box> */}

                {/* <Box
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-start' },
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      border: '1px solid',
                      borderColor: 'border.main',
                      p: 0.5,
                      borderRadius: 2,
                      overflow: 'hidden',
                      width: { xs: '100%', sm: 'auto' },
                    }}
                  >
                    <MyCarsOrOtherCarsButton value={value} setValue={setValue} />
                  </Box>
                </Box> */}
              </Box>
            </Box>
          </Box>
        </Paper>

        <Box
          sx={{
            height: 'calc(100% - 96px)',
            overflowY: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            scrollbarWidth: 'none !important' /* Firefox */,
            '-ms-overflow-style': 'none' /* IE and Edge */,
            padding: { xs: 2, sm: 3, md: 3 },
            marginBottom: { xs: 3, sm: 3, md: 3 },
          }}
        >
          {paginationData?.isFetching ? (
            // Skeleton UI
            <Box sx={{ height: '100%', width: '100%' }}>
              <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
                {[...Array(8)].map((_, index) => (
                  <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        padding: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                    {/* Car image skeleton */}
                    <Box sx={{ position: 'relative', marginBottom: 2 }}>
                      <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1.5 }} />

                      {/* Timer skeleton in top right */}
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 8,
                          right: 8,
                        }}
                      >
                        <Skeleton variant="rectangular" width={130} height={40} sx={{ borderRadius: 1 }} />
                      </Box>
                    </Box>

                    {/* Car details skeleton */}
                    <Box sx={{ marginBottom: 2 }}>
                      {/* Car title */}
                      <Skeleton variant="text" width="80%" height={24} sx={{ marginBottom: 1 }} />

                      {/* VIN */}
                      <Skeleton variant="text" width="60%" height={16} sx={{ marginBottom: 1 }} />

                      {/* Car specs grid */}
                      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, marginBottom: 2 }}>
                        {[...Array(4)].map((_, specIndex) => (
                          <Box key={specIndex}>
                            <Skeleton variant="text" width="50%" height={14} sx={{ marginBottom: 0.5 }} />
                            <Skeleton variant="text" width="70%" height={16} />
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : paginationData?.data?.length === 0 ? (
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
              textAlign: 'center',
              marginTop: { xs: '-100px', md: '-200px' },
            }}
          >
            {t('No cars are listed at the moment. Please check back later as new vehicles arrive regularly.')}
          </Typography>
        ) : (
          <Box sx={{ height: '100%', width: '100%', padding: { xs: 0, sm: 0 } }}>
            <CarsList
              isUpcomingCar={true}
              cars={paginationData?.data?.map?.((vehicle) => {
                return {
                  ...vehicle,
                  isInUpcomingCars: true,
                  dontShowPlaceABid: true,
                  // dontShowCountDown: true,
                  liveAuctionOrBuyNowTab: pageTab === pageTabs.liveAuction ? auctionTypes.liveAuction : auctionTypes.buyNow,
                  vin: vehicle?.VIN,
                  year: vehicle?.Year,
                  make: vehicle?.Make,
                  model: vehicle?.Model,
                  odometer: vehicle?.Mileage,
                  image: vehicle?.Exterior_Image
                    ? `${baseImageUrl}/${vehicle?.Vehicle_Id}/${vehicle?.Exterior_Image}`
                    : ``,
                };
              })}
              onClick={(vehicle) => {
                if (onCarClick) {
                  onCarClick(vehicle, pageTab);
                }
              }}
              Component={CarContainer1}
              ChildComponent={pageTab === pageTabs.liveAuction ? CarListingCard : VehicleListingCard}
              showCancelAuction={true}
              onCancelAuction={onCancelAuctionHandler}
              showRemainingTime={false}
              tab={auctionTypes[pageTabsReverseMapping[pageTab]]}
              cardType={carContainerTypes.UPCOMING_CARS}
              timerRemainingSecondsHandler={getUpcomingCarRemainingSeconds}
            />
            </Box>
          )}
        </Box>
      </Box>
      {/* Pagination */}
      {paginationData?.last_page > 1 ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            position: 'absolute',
            bottom: '0px',
            padding: { xs: 1, sm: 0 },
          }}
        >
          <Pagination
            count={paginationData?.last_page}
            page={paginationData?.current_page}
            onChange={handlePageChange}
            size={isMobile ? 'small' : 'medium'}
            siblingCount={isMobile ? 0 : isTablet ? 1 : 1}
            boundaryCount={isMobile ? 1 : 2}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default UpcomingCarsList;
